import { useAppSelector, useAppDispatch } from '../store/hooks';
import { 
  fetchResults, 
  fetchStatistics,
  exportResultsThunk,
  clearError,
  setFilters,
  changePage,
  clearResults
} from '../store/slices/resultsSlice';
import { ResultsFilter } from '../types/results.types';

export const useResults = () => {
  const dispatch = useAppDispatch();
  const {
    places,
    summary,
    pagination,
    filters,
    statistics,
    verifiable_emails_count,
    enrichable_people_count,
    feature_access,
    current_plan,
    auto_find_status,
    auto_find_mode,
    auto_find_success_limit,
    auto_find_success_count,
    auto_find_chargeable_count,
    auto_find_attempt_count,
    auto_find_no_email_count,
    auto_find_catch_all_count,
    auto_find_guardrail_reason,
    auto_find_business_target,
    auto_find_business_attempt_count,
    auto_find_max_people_per_business,
    auto_find_monthly_pool_limit,
    auto_find_monthly_pool_used,
    loading,
    error,
  } = useAppSelector(state => state.results);
  
  const handleFetchResults = async (searchId: number, page?: number, limit?: number, newFilters?: ResultsFilter) => {
    return await dispatch(fetchResults({
      searchId,
      page: page || pagination.page,
      limit: limit || pagination.itemsPerPage,
      filters: newFilters || filters
    }));
  };
  
  const handleFetchStatistics = async (searchId: number) => {
    await dispatch(fetchStatistics(searchId));
  };
  
  const handleExportResults = async (
    searchId: number,
    format: 'csv' | 'excel' = 'csv',
    coverage: 'ready' | 'expanded' = 'ready',
    filtersOverride?: ResultsFilter,
    includeSharedInboxes: boolean = false
  ) => {
    return await dispatch(exportResultsThunk({
      searchId,
      format,
      coverage,
      includeSharedInboxes,
      filters: filtersOverride,
    })).unwrap();
  };
  
  const handleSetFilters = (newFilters: ResultsFilter) => {
    dispatch(setFilters(newFilters));
  };
  
  const handleChangePage = (page: number) => {
    dispatch(changePage(page));
  };
  
  const handleClearResults = () => {
    dispatch(clearResults());
  };
  
  const handleClearError = () => {
    dispatch(clearError());
  };
  
  return {
    places,
    summary,
    pagination,
    filters,
    statistics,
    verifiable_emails_count,
    enrichable_people_count,
    feature_access,
    current_plan,
    auto_find_status,
    auto_find_mode,
    auto_find_success_limit,
    auto_find_success_count,
    auto_find_chargeable_count,
    auto_find_attempt_count,
    auto_find_no_email_count,
    auto_find_catch_all_count,
    auto_find_guardrail_reason,
    auto_find_business_target,
    auto_find_business_attempt_count,
    auto_find_max_people_per_business,
    auto_find_monthly_pool_limit,
    auto_find_monthly_pool_used,
    loading,
    error,
    fetchResults: handleFetchResults,
    fetchStatistics: handleFetchStatistics,
    exportResults: handleExportResults,
    setFilters: handleSetFilters,
    changePage: handleChangePage,
    clearResults: handleClearResults,
    clearError: handleClearError,
  };
}; 
